// The top bar sticks to the top of the page; sticky table headers sit just below it.
export const APP_BAR_HEIGHT = 57;
